var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#757575;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,15.1v2.2c-3.6,0-6.5,2.9-6.5,6.5H2.8C2.8,19,6.6,15.1,11.4,15.1z M11.4,14c-3.6,0-6.5-2.9-6.5-6.5 S7.8,1,11.4,1s6.5,2.9,6.5,6.5S15,14,11.4,14z M11.4,11.8c2.4,0,4.3-1.9,4.3-4.3s-1.9-4.3-4.3-4.3S7.1,5.1,7.1,7.5S9,11.8,11.4,11.8 z M14.2,20.3c-0.1-0.6-0.1-1.2,0-1.8l-1.1-0.6l1.1-1.9l1.1,0.6c0.4-0.4,1-0.7,1.5-0.9v-1.2H19v1.2c0.6,0.2,1.1,0.5,1.5,0.9l1.1-0.6 l1.1,1.9l-1.1,0.6c0.1,0.6,0.1,1.2,0,1.8l1.1,0.6l-1.1,1.9l-1.1-0.6c-0.4,0.4-1,0.7-1.5,0.9v1.2h-2.2V23c-0.6-0.2-1.1-0.5-1.5-0.9 l-1.1,0.6l-1.1-1.9C13.2,20.9,14.2,20.3,14.2,20.3z M17.9,21c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 C16.3,20.3,17,21,17.9,21z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.706a6046461ab79b6b5ac98cc5e769ca.svg";
export { ForwardRef as ReactComponent };